export const getAccessToken = () => localStorage.getItem('authToken');
export const setAccessToken = (token) => localStorage.setItem('authToken', token)

export const removeAccessToken = () => localStorage.removeItem('authToken');
export const getRefreshTokenCookie = () => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; refreshToken=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};
export const setRefreshTokenCookie = (token) => {
  const isSecure = window.location.protocol === 'https:';
  document.cookie = `refreshToken=${token}; Path=/; Max-Age=${14 * 24 * 60 * 60}; SameSite=Strict; ${
    isSecure ? 'Secure;' : ''
  }`;
};
export const removeRefreshTokenCookie = () => {
  document.cookie = 'refreshToken=; Max-Age=0; path=/';
};